module.exports = __webpack_public_path__ + "static/img/AppleMusictoLMP@3x.a378cf3.png";


//////////////////
// WEBPACK FOOTER
// ./static/assets/images/misc/3x/AppleMusictoLMP@3x.png
// module id = H89J
// module chunks = 1